// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/28328a7a222dd398a2e9.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9ec5c17e8c7a26f8e5e8","149":"5839409ef88b9456a764","150":"3bf6cc2397f9f0d4af5f"}[chunkId] + ".chunk.js";
};